<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1280px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.name"
              placeholder="请输入消费者名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData(tableList)"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.phone"
              placeholder="请输入电话"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData(tableList)"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="tableList.tableQuery.search.appletType"
              placeholder="请选择所属小程序"
              clearable
              style="width:100%"
            >
              <el-option
                :value="1"
                label="渝享荟"
              />
              <el-option
                :value="2"
                label="循香会友"
              />
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
          <el-col
            :span="5"
            style="padding-right: 20px;float: right;text-align:right;"
          >
            <el-button
              type="primary"
              @click="selectItemFun()"
            >
              选择消费者
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :multiple-selection.sync="multipleSelection"
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @selectItem="selectItemFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { loadAppConsumerListDataApi } from '@/api/appConsumer'
export default {
  name: 'ExchangeConsumerBillList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    cityId: {
      type: String,
      default: ''
    },
    certificateNo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'exchange_consumer_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'select',
            label: '选择该消费者',
            method: 'selectItem'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            name: '',
            phone: '',
            appletType: ''
          }
        }
      },
      multipleSelection: [],
      isPaging: true
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.tableList.tableQuery.search.name = ''
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'unionId', filterColumn: 'u.union_id', label: '微信统一ID', width: 140 },
          { prop: 'appletTypeStr', filterColumn: 'u.applet_type', filterValue: 'appletType', label: '所属小程序', width: 120, filterArray: [{ label: '渝享荟', value: 1 }, { label: '循香会友', value: 2 }] },
          { prop: 'name', filterColumn: 'u.name', label: '名称', width: 120 },
          { prop: 'phoneStr', filterColumn: 'u.phone', filterValue: 'phone', label: '电话', width: 120 },
          { prop: 'sexStr', filterColumn: 'u.sex', filterValue: 'sex', label: '性别', width: 110, filterArray: [{ label: '男', value: 1 }, { label: '女', value: 2 }] },
          { prop: 'provinceName', filterColumn: 'u.province_name', label: '省区', width: 120 },
          { prop: 'address', filterColumn: 'u.address', label: '详细地址', width: 160 },
          { prop: 'createDateStr', filterColumn: 'u.create_date', label: '注册日期', width: 120 },
          { prop: 'lastLoginTimeStr', filterColumn: 'u.last_login_time', label: '最近登录日期', width: 140 },
          { prop: 'integral', filterColumn: 'u.integral', label: '可用积分', width: 120 },
          { prop: 'integralTotal', filterColumn: 'u.integral_total', label: '累计积分', width: 120 },
          { prop: 'storeName', filterColumn: 'cr.store_name', label: '当前推荐店名', width: 140 },
          { prop: 'ownerName', filterColumn: 'cr.owner_name', label: '推荐店主', width: 120 },
          { prop: 'ownerPhone', filterColumn: 'cr.owner_phone', label: '店主电话', width: 120 },
          { prop: 'sourceTypeStr', filterColumn: 'u.source_type', filterValue: 'sourceType', label: '来源类型', width: 120, filterArray: [{ label: '小程序搜索', value: 0 }, { label: '零售户推荐码', value: 1 }, { label: '消费者分享', value: 2 }] },
          { prop: 'remark', filterColumn: 'u.remark', label: '备注', width: 200 }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      loadAppConsumerListDataApi(pageCondition).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 选择终端
    selectItemFun () {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请选择消费者',
          type: 'warning'
        })
        return false
      } else if (this.multipleSelection.length > 1) {
        this.$message({
          message: '只能选择一个消费者',
          type: 'warning'
        })
        return false
      } else {
        this.$emit('selectedConsumerFun', this.multipleSelection[0])
        this.modalClose()
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
